import { liteClient } from "algoliasearch/lite";
async function queryAlgolia(algoliaConfig, searchOptions) {
  const { apiKey, appId, indexName } = algoliaConfig;
  if (!apiKey || !appId || !indexName) {
    console.error(
      `[queryAlgolia]: missing ApiKey: ${apiKey}, AppId:  ${appId} or indexName : ${indexName} `
    );
    return null;
  }
  const client = liteClient(appId, apiKey);
  try {
    const result = await client.search({
      requests: [
        {
          query: searchOptions.query ?? "",
          indexName,
          ...searchOptions
        }
      ]
    });
    return result.results[0];
  } catch (error) {
    console.error(`[queryAlgolia]: Something went wrong searching Algolia.`, error);
    return null;
  }
}
export {
  queryAlgolia
};
//# sourceMappingURL=query-algolia.js.map
